import { render } from "./TokenMarkets.vue?vue&type=template&id=478c472e&scoped=true"
import script from "./TokenMarkets.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenMarkets.vue?vue&type=script&setup=true&lang=js"

import "./TokenMarkets.vue?vue&type=style&index=0&id=478c472e&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478c472e"],['__file',"resources/js/components/TokenMarkets.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "478c472e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('478c472e', __exports__)) {
    api.reload('478c472e', __exports__)
  }
  
  module.hot.accept("./TokenMarkets.vue?vue&type=template&id=478c472e&scoped=true", () => {
    api.rerender('478c472e', render)
  })

}


export default __exports__